var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("По типу заявок")]),_vm._v(" "),_c('div',{staticStyle:{"width":"300px"},attrs:{"id":"chart_reg"}},[(_vm.rendercomp)?_c('doughnut-chart',{attrs:{"chart-data":_vm.case_value,"options":_vm.case_option}}):_c('div',[_vm._v(" Нет данных ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03de1e57","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DoughnutCases.vue
// module id = null
// module chunks = 